import React, {Component} from 'react';
import {connect} from 'react-redux'
import {locale} from '../../locale/AppLocale'
import axios from 'axios';
import {NotificationManager} from '../../Helpers/NotificationManager';;
import Config from "../../Helpers/Config";
import {NavLink} from 'react-router-dom'
import {FormattedPrice} from "../../Helpers/FormattedPrice";
import ReactPaginate from 'react-paginate';

class InvoiceListing extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
            ready: false,
            failed: false,
            page: 1,
            invoices: [],
            pager: {},
        };

        this.fetchInvoices = this.fetchInvoices.bind(this);
        this.renderTable = this.renderTable.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
    }

    componentDidMount() {
        if (!this.props.auth.business.can_create_invoice) {
            this.props.history.push(`/${this.props.match.params.businessSlug}/orders/`);
        }
        this.fetchInvoices();
    }

    fetchInvoices() {
        if (this.state.page === this.state.pager.current) {
            return;
        }
        this.setState({
            fetching: true
        }, () => {
            const data = {};
            axios.post(`${Config.api()}invoice/listing/${this.props.auth.business.id}?page=${this.state.page || 1}`, data, {
                withCredentials: Config.withCredentials()
            }).then((response) => {
                if (response.data.status) {
                    this.setState({
                        fetching: false,
                        ready: true,
                        invoices: response.data.invoices,
                        pager: response.data.pager,
                    });
                } else {
                    NotificationManager.error(locale.get('an_error_occurred_while_initializing_data'));
                    this.setState({
                        fetching: false,
                        ready: true,
                        failed: true,
                    });
                }
            }).catch((error) => {
                if (typeof error.response.status !== 'undefined' && error.response.status === 401) {
                    this.props.requiresReLogin();
                } else {
                    NotificationManager.error(locale.get('an_error_occurred_while_initializing_data'));
                    this.setState({
                        fetching: false,
                        ready: true,
                        failed: true,
                    });
                }
            });
        });
    }

    render() {
        return (
            this.props.auth.business.can_create_invoice && <div>
                <div className="panel-1">
                    <div className="panel-1--head bg-white">
                        {locale.get('invoices')}
                        <NavLink to={`/${this.props.match.params.businessSlug}/invoice/create`}
                                 className="btn btn-1 btn--small pull-inverse">{locale.get('create_invoice')}</NavLink>
                    </div>
                    <div className="panel-1--body is-full">
                        {this.renderTable()}
                    </div>
                    {
                        this.state.invoices.length === 0 || this.state.pager.total_pages  === 1 ? '' : <div className="panel-1--body is-full">
                            <ReactPaginate previousLabel={locale.get('previous')}
                                           nextLabel={locale.get('next')}
                                           breakLabel={<span>...</span>}
                                           breakClassName={"break-me"}
                                           pageCount={this.state.pager.total_pages}
                                           initialPage={this.state.pager.current - 1}
                                           disableInitialCallback={true}
                                           marginPagesDisplayed={2}
                                           pageRangeDisplayed={5}
                                           onPageChange={this.onChangePage}
                                           containerClassName={"pagination"}
                                           subContainerClassName={"pages pagination"}
                                           activeClassName={"active"}/>

                        </div>

                    }
                </div>
            </div>
        )
    }


    renderTable() {
        return (<div>
            {
                this.state.invoices.length === 0 ?
                    <div className="alert alert--info text-center">{locale.get('no_invoices_found')}</div> :
                    <table className="table">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>{locale.get('email')}</th>
                            <th width={`30%`}>{locale.get('receiver_name')}</th>
                            <th>{locale.get('amount')}</th>
                            <th width={150}/>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.invoices.map((invoice, index) => {
                                return <tr key={`invoice-${index}`}>
                                    <td>{invoice.serial}</td>
                                    <td>{invoice.to_email}</td>
                                    <td>{invoice.receiver}</td>
                                    <td>{FormattedPrice(invoice.amount, '', invoice.currency)}</td>
                                    <td>
                                        <NavLink to={invoice.url} target="_blank"
                                                 className="btn btn-1 btn--small pull-inverse">{locale.get('view_invoice')}</NavLink>
                                    </td>
                                </tr>
                            })
                        }
                        </tbody>
                    </table>

            }
        </div>)
    }

    onChangePage(props) {
        let page = (props.selected + 1) || 1;

        this.setState({page: page}, () => {
            this.fetchInvoices();
        });
    }

}


// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceListing);
